export * from './app-branding-config.interface';
export * from './app-branding-config.service';
export * from './app-branding-config.mock';
export const APP_BRANDING_CONFIG_SERVICE = Symbol('AppBrandingConfigService');
